/* eslint-disable import/no-unresolved */
import { createFirebaseAccountMethods } from './firebase/account';
import { createFirebaseContext } from './firebase/context';
import { createFirebaseCore } from './firebase/core';
import { createFirebaseMfaMethods } from './firebase/mfa';
import { createFirebaseProviderMethods } from './firebase/providers';

import type { FirebaseService } from './firebase/types';

const context = createFirebaseContext();

const core = createFirebaseCore(context);

const providers = createFirebaseProviderMethods(context, {
  importAuth: core.importAuth,
  user: core.user,
  signInWithCredential: core.signInWithCredential
});

const account = createFirebaseAccountMethods(context, {
  importAuth: core.importAuth,
  user: core.user,
  isNativeAuth: core.isNativeAuth
});

const mfa = createFirebaseMfaMethods(context, {
  importAuth: core.importAuth,
  user: core.user,
  isNativeAuth: core.isNativeAuth
});

const Firebase: FirebaseService = {
  ...core,
  ...providers,
  ...account,
  ...mfa,
  getIdTokenFromNative: core.getIdToken
};

export default Firebase;
